/* eslint-disable */
import { memo, forwardRef } from "react";

// calendar.tsx
export const CalendarIcon = memo(
  forwardRef(function CalendarIcon(
    { size = 24, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-hidden={title ? undefined : true}
        focusable="false"
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.6677 9.9043H2.84375C2.42975 9.9043 2.09375 9.5683 2.09375 9.1543C2.09375 8.7403 2.42975 8.4043 2.84375 8.4043H20.6677C21.0817 8.4043 21.4177 8.7403 21.4177 9.1543C21.4177 9.5683 21.0817 9.9043 20.6677 9.9043Z"
          fill={color ?? "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1993 13.8096C15.7853 13.8096 15.4453 13.4736 15.4453 13.0596C15.4453 12.6456 15.7763 12.3096 16.1903 12.3096H16.1993C16.6133 12.3096 16.9493 12.6456 16.9493 13.0596C16.9493 13.4736 16.6133 13.8096 16.1993 13.8096Z"
          fill={color ?? "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7618 13.8096C11.3478 13.8096 11.0078 13.4736 11.0078 13.0596C11.0078 12.6456 11.3388 12.3096 11.7528 12.3096H11.7618C12.1758 12.3096 12.5118 12.6456 12.5118 13.0596C12.5118 13.4736 12.1758 13.8096 11.7618 13.8096Z"
          fill={color ?? "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.3175 13.8096C6.9035 13.8096 6.5625 13.4736 6.5625 13.0596C6.5625 12.6456 6.8945 12.3096 7.3085 12.3096H7.3175C7.7315 12.3096 8.0675 12.6456 8.0675 13.0596C8.0675 13.4736 7.7315 13.8096 7.3175 13.8096Z"
          fill={color ?? "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.1993 17.6963C15.7853 17.6963 15.4453 17.3603 15.4453 16.9463C15.4453 16.5323 15.7763 16.1963 16.1903 16.1963H16.1993C16.6133 16.1963 16.9493 16.5323 16.9493 16.9463C16.9493 17.3603 16.6133 17.6963 16.1993 17.6963Z"
          fill={color ?? "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7618 17.6963C11.3478 17.6963 11.0078 17.3603 11.0078 16.9463C11.0078 16.5323 11.3388 16.1963 11.7528 16.1963H11.7618C12.1758 16.1963 12.5118 16.5323 12.5118 16.9463C12.5118 17.3603 12.1758 17.6963 11.7618 17.6963Z"
          fill={color ?? "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.3175 17.6963C6.9035 17.6963 6.5625 17.3603 6.5625 16.9463C6.5625 16.5323 6.8945 16.1963 7.3085 16.1963H7.3175C7.7315 16.1963 8.0675 16.5323 8.0675 16.9463C8.0675 17.3603 7.7315 17.6963 7.3175 17.6963Z"
          fill={color ?? "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7969 5.791C15.3829 5.791 15.0469 5.455 15.0469 5.041V1.75C15.0469 1.336 15.3829 1 15.7969 1C16.2109 1 16.5469 1.336 16.5469 1.75V5.041C16.5469 5.455 16.2109 5.791 15.7969 5.791Z"
          fill={color ?? "currentColor"}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.71875 5.791C7.30475 5.791 6.96875 5.455 6.96875 5.041V1.75C6.96875 1.336 7.30475 1 7.71875 1C8.13275 1 8.46875 1.336 8.46875 1.75V5.041C8.46875 5.455 8.13275 5.791 7.71875 5.791Z"
          fill={color ?? "currentColor"}
        />
        <mask
          id="mask0_411_43129"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="2"
          y="2"
          width="20"
          height="21"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2 2.5791H21.5V22.5H2V2.5791Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_411_43129)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.521 4.0791C4.928 4.0791 3.5 5.4621 3.5 7.9731V17.0221C3.5 19.5881 4.928 21.0001 7.521 21.0001H15.979C18.572 21.0001 20 19.6141 20 17.0981V7.9731C20.004 6.7381 19.672 5.7781 19.013 5.1181C18.335 4.4381 17.29 4.0791 15.988 4.0791H7.521ZM15.979 22.5001H7.521C4.116 22.5001 2 20.4011 2 17.0221V7.9731C2 4.6451 4.116 2.5791 7.521 2.5791H15.988C17.697 2.5791 19.11 3.0911 20.075 4.0581C21.012 4.9991 21.505 6.3521 21.5 7.9751V17.0981C21.5 20.4301 19.384 22.5001 15.979 22.5001Z"
            fill={color ?? "currentColor"}
          />
        </g>
      </svg>
    );
  }),
);
